import type { PickersInputLocaleText } from '@mui/x-date-pickers/locales';

const fieldMonthPlaceholder: NonNullable<PickersInputLocaleText['fieldMonthPlaceholder']> = ({
  format,
}) => format;

export const datePickerLocaleText = {
  fieldMonthPlaceholder,
} satisfies Partial<PickersInputLocaleText>;
